var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"global-variables-list"}},[_c('new-menu-management-v-2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }